<template>
  <Container type="card-full" drankColor>
    <!-- <div slot="header">
      <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
    </div> -->
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">项目编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectcode" clearable></el-input>
          </div>
        </div>
        <!-- <div class="searchItem">
          <div class="label">平台编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectno" clearable></el-input>
          </div>
        </div> -->
        <div class="searchItem">
          <div class="label">项目名称</div>
          <div class="field">
            <el-input v-model.trim="query.projectname" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">采购人</div>
          <div class="field">
            <el-input v-model.trim="query.comname" clearable></el-input>
          </div>
        </div>
        <div class="searchItem" v-if="+query.comtype === 2 || +loginUser.comtype === 1">
          <div class="label">经办人</div>
          <div class="field">
            <el-input v-model.trim="query.pUsername" :disabled="pUsernameDisabled" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">状态</div>
          <div class="field">
            <el-select v-model="query.status" :clearable="true" placeholder="请选择">
              <el-option v-for="item in projectStatusList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">开始时间</div>
          <div class="field" style="width:400px;">
            <el-date-picker v-model="query.hallbegTime" type="date" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
            <div style="margin:0 10px;">
              至
            </div>
            <el-date-picker v-model="query.hallendTime" type="date" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button type='primary' @click="search">查询</el-button>
          </div>
        </div>
      </div>
    </div>
    <vggrid :list="list" tableheight="600" flexname="" :cols="cols" :showfooter="false" :showPage="true"
      :resizable="true" :defaultPage="10" :total="query.total" @cellClick="cellClick" @cellDblClick="viewProject"
      @pagechange="pagechange" :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick">
      <template slot="btn">
        <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
      </template>
    </vggrid>
  </Container>
</template>
<script>
import request from '@/utils/request'
import MenuBtn from "../common/menuBtn"
import vggrid from '../common/vggrid'
import utils from '../../assets/js/utils'
import dayjs, { Dayjs } from 'dayjs'
import moment from 'moment'
export default {
  name: 'biddingHall',
  data() {
    return {
      loginUser: this.$store.getters.loginUser,
      menuid: this.$route.query.menuid,
      pUsernameDisabled: false,
      list: [],
      btn: {},
      btnLoading: false,
      cols: [],
      project: {},
      projectStatusList: [],
      query: {
        cosid: this.$store.getters.loginUser.cosid,
        userid: this.$store.getters.loginUser.userid,
        comid: this.$store.getters.loginUser.comid,
        comtype: this.$store.getters.loginUser.comtype,
        total: 0,
        limit: 10,
        offset: 0
      }
    }
  },
  created() {
    if (this.cols.length === 0) {
      if (+this.$store.getters.loginUser.comtype === 3) {
        this.cols.push(
          { type: 'index', fieldtype: 'I', title: '行号', calculExpr: '', width: 50 },
          { field: 'projectcode', fieldtype: 'C', title: '项目编号', calculExpr: '', addNewRowFlg: false, width: 150 },
          { field: 'projectname', fieldtype: 'C', title: '项目名称', calculExpr: '', addNewRowFlg: false },
          { field: 'comfullname', fieldtype: 'C', title: '采购人', calculExpr: '', addNewRowFlg: false },
          { field: 'prsflgdesc', fieldtype: 'C', title: '交易方式', calculExpr: '', addNewRowFlg: false, width: 80 },
          { field: 'projectdoneflgdesc', fieldtype: 'C', title: '评审方法', calculExpr: '', addNewRowFlg: false, width: 120 },
          { field: 'projectisinviteCN', fieldtype: 'C', title: '报名方式', calculExpr: '', addNewRowFlg: false, width: 80 },
          { field: 'projectstatusname', fieldtype: 'C', title: '状态', calculExpr: '', addNewRowFlg: false, width: 80 },
          { field: 'projectrecusername', fieldtype: 'C', title: '建项人', calculExpr: '', addNewRowFlg: false, width: 80 },
          { field: 'prsbjbegtime', fieldtype: 'T', title: '开始时间', calculExpr: '', addNewRowFlg: false, formatter: ['toDateString', ''], width: 150 }
        )
      } else {
        this.cols.push(
          { type: 'index', fieldtype: 'I', title: '行号', calculExpr: '', width: 50 },
          { field: 'projectcode', fieldtype: 'C', title: '项目编号', calculExpr: '', addNewRowFlg: false, width: 150 },
          { field: 'projectname', fieldtype: 'C', title: '项目名称', calculExpr: '', addNewRowFlg: false },
          { field: 'comfullname', fieldtype: 'C', title: '采购人', calculExpr: '', addNewRowFlg: false },
          {
            field: "pusername",
            fieldtype: "C",
            title: "经办人",
            calculExpr: "",
            addNewRowFlg: false,
            width: 80,
          },
          { field: 'projectlimitamtdesc', fieldtype: 'C', title: '项目预算', calculExpr: '', addNewRowFlg: false },
          { field: 'prsflgdesc', fieldtype: 'C', title: '交易方式', calculExpr: '', addNewRowFlg: false, width: 80 },
          { field: 'projectdoneflgdesc', fieldtype: 'C', title: '评审方法', calculExpr: '', addNewRowFlg: false, width: 120 },
          { field: 'projectisinviteCN', fieldtype: 'C', title: '报名方式', calculExpr: '', addNewRowFlg: false, width: 80 },
          { field: 'projectstatusname', fieldtype: 'C', title: '状态', calculExpr: '', addNewRowFlg: false, width: 80 },
          { field: 'projectrecusername', fieldtype: 'C', title: '建项人', calculExpr: '', addNewRowFlg: false, width: 80 },
          { field: 'prsbjbegtime', fieldtype: 'T', title: '开始时间', calculExpr: '', addNewRowFlg: false, formatter: ['toDateString', ''], width: 150 }
        )
      }
    }
  },
  activated() {
    this.init()
    this.TBJJbtn()
    this.getPageList()
    this.getProjectStatusList()
  },
  mounted() {
  },
  watch: {
  },
  components: { MenuBtn, vggrid },
  methods: {
    async getProjectStatusList() {
      this.projectStatusList = await request({
        url: '/kfgl/syscode/getSysCodeList',
        method: "get",
        params: { syscode: 'projectstatus' }
      })
    },
    btnClick(code) {
      this.$emit(code)
    },
    vggridClick(code, row) {
      this.project = row
      this.$emit(code, row)
    },
    btnmenuclick(btn) {
      this.btn = btn
    },
    async init() {
      this.list = []
      this.btnLoading = false
      this.project = {}
      this.menuid = this.$route.query.menuid || this.$route.params.menuid
      if (+this.query.comtype === 2 && +this.$store.getters.loginUser.roletype === 2) {
        this.query.pUsername = this.$store.getters.loginUser.username
        this.pUsernameDisabled = true
      }
    },
    async projectAnnouncement(name, wmenudatawhere) {
      if (!this.project.projectid) {
        this.$message.warning('请选择一个项目!')
        return
      }
      let wmenu = await request({
        method: 'get',
        url: '/ywgl/wmenu/getWmenuId',
        params: { wmenudatawhere: wmenudatawhere }
      })
      let form = {
        project: this.project,
        pjnoticefromid: this.project.projectid,
        wmenuid: wmenu[0].wmenuid,
        wmenuname: name,
        wmenudatawhere: wmenudatawhere
      }
      this.$router.push({ name: 'pjnoticeIndex', params: { form: form } })
    },
    async TBJJbtn() {
      //供应商进去操作列表
      let nowdate = await request({
        method: 'get',
        url: 'xtgl/sysdata'
      })
      if (this.cols[this.cols.length - 1].title == '操作 ' && !this.btn.isOperate) this.cols.pop()
      this.cols.push({
        title: '操作 ', width: 100, showOverflow: true,
        slots: {
          default: ({ row }) => {
            const nowdate = dayjs() // 当天的开始时间
            const tomorrowStart = dayjs(row.prsbjendtime).add(1, 'day').startOf('day'); // 明天的开始时间
            const bjendTime = dayjs(row.prsbjendtime)
            if (new Date(row.projectjkactualendtime).getTime() <= new Date(nowdate).getTime() && row.projectjkactualendtime != null) {
              return [<vxe-button type='primary' onClick={this.goView.bind(this, row)}>查看</vxe-button>]
            }
            if (new Date(row.prsbmbegtime).getTime() <= new Date(nowdate).getTime() && new Date(row.prsbjendtime).getTime() >= new Date(nowdate).getTime()) {
              if (+row.prsflg === 1 || +row.prsflg === 3) {
                return [<vxe-button type='primary' onClick={this.goJJorTB.bind(this, row)}>报价大厅</vxe-button>]
              }
              else if (+row.prsflg === 4 || +row.prsflg === 5) {
                return [<vxe-button type='primary' onClick={this.goJJorTB.bind(this, row)}>报价大厅</vxe-button>]
              }
              else if (+row.prsflg === 6) {
                return [<vxe-button type='primary' onClick={this.goJJorTB.bind(this, row)}>报价大厅</vxe-button>]
              }
            }
            // console.log(&& (row.projectstopflg !== null && row.projectstopflg!==1)  && (row.projectcancelflg !== 1 && row.projectcancelflg !== null))
            if (new Date(row.prsbmbegtime).getTime() <= new Date(nowdate).getTime() && row.projectjkactualendtime == null && (row.projectstopflg == null || +row.projectstopflg !== 1) && (row.projectcancelflg == null || +row.projectcancelflg !== 1 ) ) {
              // if (isAfterNextDayStart) {
              //   return [<vxe-button type='primary' onClick={this.goJJorTB.bind(this, row)}>查看</vxe-button>]
              // }
              if (dayjs().isAfter(tomorrowStart) && dayjs().isAfter(bjendTime)) {
                return [<vxe-button type='primary' onClick={this.goJJorTB.bind(this, row)}>查看</vxe-button>]
              }
              if (+row.prsflg === 1 || +row.prsflg === 3) {
                return [<vxe-button type='primary' onClick={this.goJJorTB.bind(this, row)}>报价大厅</vxe-button>]
              }
              else if (+row.prsflg === 4 || +row.prsflg === 5) {
                return [<vxe-button type='primary' onClick={this.goJJorTB.bind(this, row)}>报价大厅</vxe-button>]
              }
              else if (+row.prsflg === 6) {
                return [<vxe-button type='primary' onClick={this.goJJorTB.bind(this, row)}>报价大厅</vxe-button>]
              }
              // 当前时间是否在报价截止时间+1天之后
              // else if (!bjendTime.isAfter(nowdate) && !bjendTime.isAfter(tomorrowStart)) {
              //   return [<vxe-button type='primary' onClick={this.goJJorTB.bind(this, row)}>查看</vxe-button>]
              // }
            }
            else {
              return [<vxe-button type='primary' onClick={this.goView.bind(this, row)}>查看</vxe-button>]
            }
          }
        }
      })
    },
    async goView(row) {
      if (+this.$store.getters.loginUser.comtype === 3 && +row.prsisopen === 1) {
          if (row.projectcancelflg !== null && +row.projectcancelflg===1) {
            this.$message.warning('项目采购失败不公开报价')
            return
          }
          const notice = await request({
            method: 'get',
            url: '/xmgl/pjnotice/getSuccessPjNotice',
            params: {
              pjnoticeprojectid: row.projectid,
            }
          })
          if (notice) {
            this.$router.push({ name: 'biddingView', params: { project: this.project, type: 1 } })
            return
          }
          else {
            this.$message.warning('采购结果发布前不公开报价')
            return
          }
        } 
        else {
          this.project = row
          this.$router.push({ name: 'biddingView', params: { project: this.project, type: 1 } })
        }
     
    },
    async goJJorTB(row) {
      this.project = row
      if (+this.project.projectstopflg === 1) {
        this.$message.warning('项目已终止')
        return
      }
      if (+this.project.projectcancelflg === 1) {
        this.$message.warning('项目采购失败')
        return
      }
      if (this.project.psuid) {
        let res = await request({
          method: 'get',
          url: '/xmgl/project/getPsuListByComId',
          params: {
            projectid: this.project.projectid,
            comid: this.$store.getters.loginUser.comid,
            cosid: this.$store.getters.loginUser.cosid,
            offset: 0, limit: 1,
          }
        })
        if (+res.list[0].projectbmamt > 0) {
          if (+res.list[0].psubmpaytype === 0) {
            this.$message.warning('还未支付报名费')
            return
          }
          if (+res.list[0].psubmpayflg !== 1) {
            this.$message.warning('报名费未确认')
            return
          }
        }
        if (+res.list[0].projectbzjamt > 0) {
          if (+res.list[0].psubzjpaytype === 0) {
            this.$message.warning('还未支付保证金')
            return
          }
          if (+res.list[0].psubzjpayflg !== 1) {
            this.$message.warning('保证金未确认')
            return
          }
        }
      }
      let nowdate = await request({
        method: 'get',
        url: 'xtgl/sysdata'
      })
      let name = ''
      if (+row.prsflg === 6)
        name = '比选'
      else
        name = '竞价'
      if (moment(new Date(nowdate).getTime() + 0.5 * 3600 * 1000).isBefore(this.project.prsbjbegtime)) {
        this.$message.warning(`未到${name}开始时间`)
        return
      }
      if (+row.prsflg === 1 || +row.prsflg === 3 || +row.prsflg === 6)
        this.$router.push({ name: 'pbrCenterForm', params: { projectid: this.project.projectid, psuid: this.project.psuid, type: 1 } })

      if (+row.prsflg === 4 || +row.prsflg === 5)
        this.$router.push({ name: 'auctionHall', params: { projectid: this.project.projectid, psuid: this.project.psuid, type: 1 } })
    },
    async viewProject(row) {
      this.project = row.row
      if (this.project.psuid) {
        this.$router.push({ name: 'projectView', params: { projectid: this.project.projectid, psuid: this.project.psuid, innerbtn: this.btn.inner } })
      }
      else {
        this.$router.push({ name: 'projectView', params: { projectid: this.project.projectid, innerbtn: this.btn.inner } })
      }
    },
    async cellClick(row) {
      this.project = row.row
    },
    async pagechange(page) {
      this.query.offset = page.pageSize * (page.currentPage - 1)
      this.query.limit = page.pageSize
      this.getPageList()
    },
    search() {
      this.query.offset = 0
      if (this.query.hallendTime) {
        this.query.hallendtime = dayjs(this.query.hallendTime).add(1, 'day').format('YYYY-MM-D')
      }
      this.getPageList()
    },
    async getPageList() {
      this.loading = true
      this.query.isJJorTB = 1
      this.query.cosid = this.$store.getters.loginUser.cosid
      this.query.areaid = 0
      // this.query.failproject = 2 
      this.query.selectField = `prsisopen,projectcode,projectlimitamt,projectstopflg,projectcancelflg,projectptccode,projectname,prsbjbegtime,projectid,prsbjbegtime,prsflg,prsbmbegtime,projectjkactualendtime,prsbmbegtime,prsbjendtime,projectstatus,projectisinvite`
      this.query.selectPsuField = `prsisopen,projectcode,projectlimitamt,projectstopflg,projectcancelflg,projectptccode,projectname,prsbjbegtime,projectid,psuid,prsbjbegtime,prsflg,prsbmbegtime,projectjkactualendtime,prsbmbegtime,prsbjendtime,projectstatus,projectisinvite`
      let res
      if (+this.query.comtype === 2) {
        res = await request({
          method: "get",
          url: "/xmgl/project/getPurchaserPageList",
          params: this.query,
        });
      }
      else if (+this.query.comtype === 3) {
        res = await request({
          method: 'get',
          url: '/xmgl/project/getPsuListByComId',
          params: this.query
        })
      }
      else {
        res = await request({
          method: 'get',
          url: '/xmgl/project/getPageList',
          params: this.query
        })
      }
      this.list = res.list
      res.list.forEach(e => {
        e.projectisinviteCN = +e.projectisinvite === 1 ? '邀请' : '公开'
        e.projectlimitamtdesc = e.projectlimitamt ? utils.comdify(e.projectlimitamt) : e.projectlimitamt
      });
      this.query.total = res.count[0].count
      this.loading = false
    }
  }
}
</script>
<style lang="scss">

</style>
